import React from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import Currency from '../../currency'
import PaymentTerm from './payment_term'

const RADIO_CLASSES = "size-5 shrink-0 cursor-pointer appearance-none rounded-full border-2 border-border outline-none before:m-[25%] before:block before:size-1/2 before:rounded-full before:content-[''] checked:border-foreground checked:before:bg-foreground hover:border-muted-foreground/40"

class FinaliseOrder extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selected_order: null,
      create_new_order: true,
      open: false
    }
  }

  onOpenChange = (open) => {
    this.setState({open})
  }

  onOrderClicked = (order_id) => {
    this.setState({
      selected_order: order_id,
      create_new_order: false
    })
  }

  onCreateNewOrderClicked = () => {
    this.setState({
      create_new_order: true,
      selected_order: null
    })
  }

  onCancel = () => {
    this.setState({
      create_new_order: true,
      selected_order: null,
      open: false
    })
  }

  onProceed = () => {
    if (this.state.create_new_order) {
      this.props.onPlaceOrder()
    }
    else if (this.state.selected_order) {
      this.props.onAddToOrder(this.state.selected_order)
    }
    this.setState({open: false})
  }

  render() {
    const orders = this.props.lesson_order.orders
    let newOrderChecked = this.state.create_new_order

    return (
      <Popover open={this.state.open} onOpenChange={this.onOpenChange}>
        <PopoverTrigger asChild>
          <Button size="lg" className="w-full mb-2">
            Finalise <ChevronDown className="size-4"/>
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" collisionPadding={16} className="w-auto min-w-[min(700px,var(--radix-popover-content-available-width))] max-w-(--radix-popover-content-available-width) max-h-(--radix-popover-content-available-height) overflow-y-auto">
          <div>
            <div
              className={cn(
                'grid grid-cols-12 items-center gap-2 rounded p-2 mb-2 cursor-pointer',
                newOrderChecked ? 'bg-primary/5 text-primary' : 'hover:bg-muted/50'
              )}
              onClick={() => this.onCreateNewOrderClicked()}
            >
              <div className="col-span-3 flex items-center">
                <input className={cn(RADIO_CLASSES, 'mr-2')} type="radio" checked={newOrderChecked} readOnly/>
                <label className="mb-0">
                  Create New Order
                </label>
              </div>
              <div className="col-span-5">{this.props.lesson_order.job_description}</div>
              <div className="col-span-4 flex flex-col items-end text-right">
                <PaymentTerm payment_term={this.props.lesson_order.payment_term}/>
                <Currency value={this.props.lesson_order.amount} currency={this.props.lesson_order.currency_code} placeholder='-' />
              </div>
            </div>

            {_.map(orders, (order) => {
              let orderChecked = this.state.selected_order == order.id

              return (
                <div
                  key={order.id}
                  className={cn(
                    'grid grid-cols-12 items-center gap-2 rounded p-2 mb-2 cursor-pointer',
                    orderChecked ? 'bg-primary/5 text-primary' : 'hover:bg-muted/50'
                  )}
                  onClick={() => this.onOrderClicked(order.id)}
                >
                  <div className="col-span-3 flex items-center">
                    <input className={cn(RADIO_CLASSES, 'mr-2')} type="radio" checked={orderChecked} readOnly/>
                    <label className="mb-0">
                      {"Add to Order " + order.id}
                    </label>
                  </div>
                  <div className="col-span-3">{order.description}</div>
                  <div className="col-span-2 text-center">
                    {order.paid ?
                      <Badge variant="success" className="font-bold">Paid</Badge>
                      : <Badge variant="secondary" className="font-bold">Unpaid</Badge>
                    }
                  </div>
                  <div className="col-span-4 flex flex-col items-end text-right">
                    <PaymentTerm payment_term={order.payment_term}/>
                    <Currency value={order.total} currency={order.currency_code} placeholder='-' />
                  </div>
                </div>
              )
            })}
            <div className="flex justify-end gap-2">
              <Button size="sm" onClick={this.onProceed}>Proceed</Button>
              <Button variant="destructive" size="sm" onClick={this.onCancel}>Cancel</Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    )
  }

}

export default FinaliseOrder
